import { Link } from 'react-router-dom';

const footerLinks = {
  platform: [
    { label: 'Nasıl Çalışır', href: '#nasil-calisir' },
    { label: 'Terapistler İçin', href: '#terapistler-icin' },
    { label: 'Spa İşletmeleri İçin', href: '#spa-isletmeleri-icin' },
    { label: 'Kredi Modeli', href: '#kredi-modeli' },
  ],
  company: [
    { label: 'Güvenlik', href: '#guvenlik' },
    { label: 'KVKK', href: '#' },
    { label: 'Kullanım Koşulları', href: '#' },
    { label: 'İletişim', href: '#' },
  ],
};

export default function Footer() {
  const scrollTo = (href: string) => {
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-deep-navy-500 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-dark-teal-500 flex items-center justify-center text-white text-sm font-bold">
                S
              </span>
              <span className="font-sans font-bold text-lg">SpaProBridge</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Spa ve wellness sektöründe profesyonel terapistler ile işletmeleri güvenli, gizlilik odaklı ve kontrollü şekilde eşleştiren kredi bazlı SaaS platformu.
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-soft-gold-400">Platform</h4>
            <ul className="space-y-3">
              {footerLinks.platform.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-soft-gold-400">Şirket</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social & CTA */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-soft-gold-400">Bizi Takip Edin</h4>
            <div className="flex gap-3 mb-6">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-colors"
                rel="noopener noreferrer"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-colors"
                rel="noopener noreferrer"
              >
                <i className="ri-linkedin-line text-lg" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-colors"
                rel="noopener noreferrer"
              >
                <i className="ri-twitter-x-line text-lg" />
              </a>
            </div>
            <p className="text-xs text-gray-500">
              İlk aşamada Kayseri, Antalya ve İstanbul'da hizmet verilmektedir.
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; 2026 SpaProBridge. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
              Gizlilik Politikası
            </Link>
            <Link to="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
              Kullanım Koşulları
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}